import React from "react"
import { Provider } from "react-redux"
import configureStore from "./configureStore"
import { saveState } from "./localStorage"

export const store = configureStore()

store.subscribe(() => {
    saveState({ shoppingCart: store.getState().shoppingCart })
})

export default ({ element }) => <Provider store={store}>{element}</Provider>
